import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Software Engineer",
          "Backend & Distributed Systems"
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 40,
        delay: 50,
      }}
    />
  );
}

export default Type;
